(function () {
  'use strict';

  function syncHostTypography(root) {
    if (!root || !document.body || typeof window.getComputedStyle !== 'function') return;

    var probe = null;
    try {
      var bodyStyle = window.getComputedStyle(document.body);
      probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:fixed;left:-10000px;top:0;width:1px;height:1px;overflow:hidden;visibility:hidden;pointer-events:none;contain:layout style;';

      ['h1', 'h2', 'h3', 'h4', 'h0', 'hxl', 'hxxl'].forEach(function (level) {
        var isNativeHeading = /^h[1-6]$/.test(level);
        var heading = document.createElement(isNativeHeading ? level : 'div');
        heading.className = level;
        heading.dataset.swishPreviewTypographyLevel = level;
        heading.textContent = 'Swish';
        heading.style.margin = '0';
        heading.style.padding = '0';
        probe.appendChild(heading);
      });
      document.body.appendChild(probe);

      var headings = {};
      Array.prototype.forEach.call(probe.children, function (heading) {
        headings[heading.dataset.swishPreviewTypographyLevel] = window.getComputedStyle(heading);
      });

      function setValue(name, value) {
        if (value) root.style.setProperty(name, value);
      }

      setValue('--swish-preview-host-body-family', bodyStyle.fontFamily);
      setValue('--swish-preview-host-body-size', bodyStyle.fontSize);
      setValue('--swish-preview-host-body-line-height', bodyStyle.lineHeight);
      setValue('--swish-preview-host-body-weight', bodyStyle.fontWeight);
      setValue('--swish-preview-host-heading-family', headings.h2 && headings.h2.fontFamily);

      ['h1', 'h2', 'h3', 'h4', 'h0', 'hxl', 'hxxl'].forEach(function (level) {
        var style = headings[level];
        if (!style) return;
        setValue('--swish-preview-host-' + level + '-size', style.fontSize);
        setValue('--swish-preview-host-' + level + '-line-height', style.lineHeight);
        setValue('--swish-preview-host-' + level + '-weight', style.fontWeight);
      });

      root.setAttribute('data-swish-preview-host-typography', 'ready');
    } catch (_) {
      try {
        root.setAttribute('data-swish-preview-host-typography', 'fallback');
      } catch (_) {}
    } finally {
      try {
        if (probe && probe.parentNode) probe.parentNode.removeChild(probe);
      } catch (_) {}
    }
  }

  function initialize(root) {
    if (!root || root.dataset.swishPreviewColumnReady === '1') return;

    root.dataset.swishPreviewColumnReady = '1';
    syncHostTypography(root);

    try {
      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(function () {
          syncHostTypography(root);
        }).catch(function () {});
      }
    } catch (_) {}

  }

  function initializeAll(scope) {
    var root = scope && scope.matches && scope.matches('[data-swish-preview-column]') ? scope : null;
    if (root) initialize(root);

    var searchRoot = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(searchRoot.querySelectorAll('[data-swish-preview-column]'), initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
